var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statuslist"},_vm._l((_vm.ristStatus),function(item){return _c('div',{key:item.id,class:_vm.activeIndex == item.id ? 'active ristStatus' : 'ristStatus'},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }